import { createSelector } from '@reduxjs/toolkit';
import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { selectImprovementsCost } from './selectImprovementsCost.ts';
import { selectSiteValue } from './selectSiteValue.ts';

export const selectPropertyValueById = createSelector(
  [
    selectImprovementsCost,
    selectSiteValue
  ],
  (improvementsCost, siteValue) => {
    if (isUndefined(improvementsCost) || isUndefined(siteValue)) {
      return undefined;
    }

    return improvementsCost.add(siteValue);
  }
)

export const selectPropertyValueDisplayById = createSelector(
  [selectPropertyValueById],
  (propertyValue) => {
    if (isUndefined(propertyValue)) {
      return undefined;
    }

    return propertyValue.toString(true);
  }
);
